<script>
  import { domainName, record } from '../stores.js';
</script>

<div class="record-box record-raw">
  <div id="headingRaw" class="box-label">
    <h5>BIMI Record Found: <span>{$domainName}</span></h5>
    <button type="button" class="btn-collapse" data-toggle="collapse" data-target="#collapseRaw" aria-expanded="true" aria-controls="collapseRaw" aria-label="Close"></button>
  </div>
  <div id="collapseRaw" class="box-detail collapse show" aria-labelledby="headingRaw">
    <div class="color-box">
      <p>{$record.bimi.value}</p>
    </div>
  </div>
</div>

<style>

</style>
